export const ANAL_SEC_LIST_ALL_REQUESTING = 'ANAL_SEC_LIST_ALL_REQUESTING';
export const ANAL_SEC_LIST_ALL_SUCCESS = 'ANAL_SEC_LIST_ALL_SUCCESS';
export const ANAL_SEC_LIST_ALL_ERROR = 'ANAL_SEC_LIST_ALL_ERROR';

export const ANAL_STOCK_REAL_REQUESTING = 'ANAL_STOCK_REAL_REQUESTING';
export const ANAL_STOCK_REAL_SUCCESS = 'ANAL_STOCK_REAL_SUCCESS';
export const ANAL_STOCK_REAL_ERROR = 'ANAL_STOCK_REAL_ERROR';

export const ANAL_STOCK_MATCH_PRICE_REQUESTING = 'ANAL_STOCK_MATCH_PRICE_REQUESTING';
export const ANAL_STOCK_MATCH_PRICE_SUCCESS = 'ANAL_STOCK_MATCH_PRICE_SUCCESS';
export const ANAL_STOCK_MATCH_PRICE_ERROR = 'ANAL_STOCK_MATCH_PRICE_ERROR';

export const ANAL_STOCK_MB_ACTIVE_REQUESTING = 'ANAL_STOCK_MB_ACTIVE_REQUESTING';
export const ANAL_STOCK_MB_ACTIVE_SUCCESS = 'ANAL_STOCK_MB_ACTIVE_SUCCESS';
export const ANAL_STOCK_MB_ACTIVE_ERROR = 'ANAL_STOCK_MB_ACTIVE_ERROR';

export const ANAL_BASIC_INFO_REQUESTING = 'ANAL_BASIC_INFO_REQUESTING';
export const ANAL_BASIC_INFO_SUCCESS = 'ANAL_BASIC_INFO_SUCCESS';
export const ANAL_BASIC_INFO_ERROR = 'ANAL_BASIC_INFO_ERROR';

export const ANAL_INDEX_REAL_REQUESTING = 'ANAL_INDEX_REAL_REQUESTING';
export const ANAL_INDEX_REAL_SUCCESS = 'ANAL_INDEX_REAL_SUCCESS';
export const ANAL_INDEX_REAL_ERROR = 'ANAL_INDEX_REAL_ERROR';

export const ANAL_NN_INDAY_REQUESTING = 'ANAL_NN_INDAY_REQUESTING';
export const ANAL_NN_INDAY_SUCCESS = 'ANAL_NN_INDAY_SUCCESS';
export const ANAL_NN_INDAY_ERROR = 'ANAL_NN_INDAY_ERROR';

export const ANAL_NN_10DAY_REQUESTING = 'ANAL_NN_10DAY_REQUESTING';
export const ANAL_NN_10DAY_SUCCESS = 'ANAL_NN_10DAY_SUCCESS';
export const ANAL_NN_10DAY_ERROR = 'ANAL_NN_10DAY_ERROR';

export const ANAL_PB_DONG_TIEN_REQUESTING = 'ANAL_PB_DONG_TIEN_REQUESTING';
export const ANAL_PB_DONG_TIEN_SUCCESS = 'ANAL_PB_DONG_TIEN_SUCCESS';
export const ANAL_PB_DONG_TIEN_ERROR = 'ANAL_PB_DONG_TIEN_ERROR';

export const ANAL_LICH_SU_GIA_REQUESTING = 'ANAL_LICH_SU_GIA_REQUESTING';
export const ANAL_LICH_SU_GIA_SUCCESS = 'ANAL_LICH_SU_GIA_SUCCESS';
export const ANAL_LICH_SU_GIA_ERROR = 'ANAL_LICH_SU_GIA_ERROR';

export const ANAL_FS_RATIO_REQUESTING = 'ANAL_FS_RATIO_REQUESTING';
export const ANAL_FS_RATIO_SUCCESS = 'ANAL_FS_RATIO_SUCCESS';
export const ANAL_FS_RATIO_ERROR = 'ANAL_FS_RATIO_ERROR';

export const ANAL_RANK_FS_RATIO_REQUESTING = 'ANAL_RANK_FS_RATIO_REQUESTING';
export const ANAL_RANK_FS_RATIO_SUCCESS = 'ANAL_RANK_FS_RATIO_SUCCESS';
export const ANAL_RANK_FS_RATIO_ERROR = 'ANAL_RANK_FS_RATIO_ERROR';

export const ANAL_SEC_OVERVIEW_REQUESTING = 'ANAL_SEC_OVERVIEW_REQUESTING';
export const ANAL_SEC_OVERVIEW_SUCCESS = 'ANAL_SEC_OVERVIEW_SUCCESS';
export const ANAL_SEC_OVERVIEW_ERROR = 'ANAL_SEC_OVERVIEW_ERROR';

export const ANAL_COMPANY_INTRODUCTION_REQUESTING = 'ANAL_COMPANY_INTRODUCTION_REQUESTING';
export const ANAL_COMPANY_INTRODUCTION_SUCCESS = 'ANAL_COMPANY_INTRODUCTION_SUCCESS';
export const ANAL_COMPANY_INTRODUCTION_ERROR = 'ANAL_COMPANY_INTRODUCTION_ERROR';

export const ANAL_COMPANY_BASIC_REQUESTING = 'ANAL_COMPANY_BASIC_REQUESTING';
export const ANAL_COMPANY_BASIC_SUCCESS = 'ANAL_COMPANY_BASIC_SUCCESS';
export const ANAL_COMPANY_BASIC_ERROR = 'ANAL_COMPANY_BASIC_ERROR';

export const ANAL_COMPANY_SAME_IND_REQUESTING = 'ANAL_COMPANY_SAME_IND_REQUESTING';
export const ANAL_COMPANY_SAME_IND_SUCCESS = 'ANAL_COMPANY_SAME_IND_SUCCESS';
export const ANAL_COMPANY_SAME_IND_ERROR = 'ANAL_COMPANY_SAME_IND_ERROR';

export const ANAL_COMPANY_LEADER_REQUESTING = 'ANAL_COMPANY_LEADER_REQUESTING';
export const ANAL_COMPANY_LEADER_SUCCESS = 'ANAL_COMPANY_LEADER_SUCCESS';
export const ANAL_COMPANY_LEADER_ERROR = 'ANAL_COMPANY_LEADER_ERROR';

export const ANAL_COMPANY_HOLDER_REQUESTING = 'ANAL_COMPANY_HOLDER_REQUESTING';
export const ANAL_COMPANY_HOLDER_SUCCESS = 'ANAL_COMPANY_HOLDER_SUCCESS';
export const ANAL_COMPANY_HOLDER_ERROR = 'ANAL_COMPANY_HOLDER_ERROR';

export const ANAL_COMPANY_EVENTS_REQUESTING = 'ANAL_COMPANY_EVENTS_REQUESTING';
export const ANAL_COMPANY_EVENTS_SUCCESS = 'ANAL_COMPANY_EVENTS_SUCCESS';
export const ANAL_COMPANY_EVENTS_ERROR = 'ANAL_COMPANY_EVENTS_ERROR';

export const ANAL_COMPANY_BIGTRANS_REQUESTING = 'ANAL_COMPANY_BIGTRANS_REQUESTING';
export const ANAL_COMPANY_BIGTRANS_SUCCESS = 'ANAL_COMPANY_BIGTRANS_SUCCESS';
export const ANAL_COMPANY_BIGTRANS_ERROR = 'ANAL_COMPANY_BIGTRANS_ERROR';

export const ANAL_COMPANY_RELATED_REQUESTING = 'ANAL_COMPANY_RELATED_REQUESTING';
export const ANAL_COMPANY_RELATED_SUCCESS = 'ANAL_COMPANY_RELATED_SUCCESS';
export const ANAL_COMPANY_RELATED_ERROR = 'ANAL_COMPANY_RELATED_ERROR';

export const ANAL_FILTER_RANGE_REQUESTING = 'ANAL_FILTER_RANGE_REQUESTING';
export const ANAL_FILTER_RANGE_SUCCESS = 'ANAL_FILTER_RANGE_SUCCESS';
export const ANAL_FILTER_RANGE_ERROR = 'ANAL_FILTER_RANGE_ERROR';

export const ANAL_FILTER_ACT_REQUESTING = 'ANAL_FILTER_ACT_REQUESTING';
export const ANAL_FILTER_ACT_SUCCESS = 'ANAL_FILTER_ACT_SUCCESS';
export const ANAL_FILTER_ACT_ERROR = 'ANAL_FILTER_ACT_ERROR';

export const ANAL_USER_FILTER_REQUESTING = 'ANAL_USER_FILTER_REQUESTING';
export const ANAL_USER_FILTER_SUCCESS = 'ANAL_USER_FILTER_SUCCESS';
export const ANAL_USER_FILTER_ERROR = 'ANAL_USER_FILTER_ERROR';

export const ANAL_USER_SIGNAL_REQUESTING = 'ANAL_USER_SIGNAL_REQUESTING';
export const ANAL_USER_SIGNAL_SUCCESS = 'ANAL_USER_SIGNAL_SUCCESS';
export const ANAL_USER_SIGNAL_ERROR = 'ANAL_USER_SIGNAL_ERROR';

export const ANAL_DEL_FILTER_REQUESTING = 'ANAL_DEL_FILTER_REQUESTING';
export const ANAL_DEL_FILTER_SUCCESS = 'ANAL_DEL_FILTER_SUCCESS';
export const ANAL_DEL_FILTER_ERROR = 'ANAL_DEL_FILTER_ERROR';
